import { Alert, Box } from '@mui/material';
import { useLocation } from 'react-router';

export const NotFoundView = () => {
	const location = useLocation();
	return (
		<Box
			component='section'
			sx={{
				flex: 1,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			}}>
			<Alert severity='error'>{`Page Not Found: ${location.pathname}`}</Alert>
		</Box>
	);
};
